import * as areaParameterActionTypes from './areaParametersActionTypes';

export const addAreaParameter = (areaParameter) => ({
  type: areaParameterActionTypes.ADD_AREA_PARAMETER,
  areaParameter,
});

export const updateAreaParameter = (areaParameter) => ({
  type: areaParameterActionTypes.UPDATE_AREA_PARAMETER,
  areaParameter,
});

export const deleteAreaParameter = (areaParameter) => ({
  type: areaParameterActionTypes.DELETE_AREA_PARAMETER,
  areaParameter,
});



// WEBPACK FOOTER //
// ./src/areaParameters/areaParameterActions.js